<template>
	<div class="class">
		<!--顶部搜索框 -->
		<div class="nav">
			<van-icon name="arrow-left" size="1.2rem" color="#fff" @click="home" />
			<van-col span="24">
				<van-search class="special_serch" @focus="serch" placeholder="办公桌" shape="round" background="#f1452f">
				</van-search>
			</van-col>
		</div>
		<van-swipe :autoplay="3000" indicator-color="white">
			<van-swipe-item v-for="item in imgList">
				<img :src="item" alt="">
			</van-swipe-item>
		</van-swipe>
		<!-- 侧边导航栏 -->
		<div class="nav_sidebar">
			<van-sidebar v-model="activeKey">
				<van-sidebar-item :class="[activeKey==0?'biancu':'']" title="以租代购" @click="rent(1,0)" />
				<van-sidebar-item :class="[activeKey==1?'biancu':'']" title="精品二手" @click="rent(3,1)" />
				<van-sidebar-item title="限时抢购" to="limit" />
				<van-sidebar-item title="整装整租" to="packages" />
				<van-sidebar-item title="闲具自贸" to="home_undete" />
				<van-sidebar-item title="办公链" to="home_sever" />
				<van-sidebar-item title="招标投标" to="bid" />
				<van-sidebar-item title="家具头条" to="newList" />
				<!-- <van-sidebar-item title="在线展厅" to="exh" /> -->
				<van-sidebar-item title="方案获取" to="design" />
			</van-sidebar>
			<div class="main">
				<div style="position: relative;" v-for="(item,index) in classList" :key="index">
					<p class="fenleiming">{{item.title}}</p>
					<div class="menu" id="menu">
						<div v-for="items in item['tags']" @click="goPage(items.id)">
							<img :src="items.image | handleUrl" alt="">
							<span>{{items.title}}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footbar></Footbar>

	</div>
</template>

<script>
	import Footbar from '@/components/footbar';

	export default {
		name: 'class',
		data() {
			return {
				activeKey: localStorage.getItem("activeKeys") || 0,
				imgList: [
					'https://backstage.jbj-china.com.cn/image/img/class.png',
					'http://image.jbj-china.com.cn/img/class2.png',
					'http://image.jbj-china.com.cn/img/class3.png',
					'http://image.jbj-china.com.cn/img/class4.png',
				],
				classList: [],
				category_id: localStorage.getItem("category_ids") || 1,
				tabs: [],
				design: [],
				flag: 0,
				sverList: [],
			}
		},
		components: {
			Footbar
		},
		mounted() {
			//methodName为自定义方法名  （这句代码是关键）
			window.wxlogin = this.wxlogin;
		},
		created() {
			window.wxlogin = this.wxlogin;
			if (this.$route.query.activeKey) {
				this.activeKey = this.$route.query.activeKey;
				switch (this.$route.query.activeKey) {
					case '0':
						this.category_id = 1;
						break;
					case '1':
						this.category_id = 2;
						break;
					case '2':
						this.category_id = 3;
						break;
				}
			}
			//租购淘
			this.$axios.post(baseUrl + '/mobile/Category/goodsCategory').then((res) => {
				if (res.data.code == 2) {
					this.classList = res.data.data.tags_category;
				}
			}).catch((err) => {
				console.log(err);
			});
			//第三方服务
			if (sessionStorage.getItem("fenlei4") == null) {
				this.$axios.post(baseUrl + '/mobile/Category/thirdparty')
					.then((res) => {
						if (res.data.code == 2) {
							sessionStorage.setItem("fenlei4", JSON.stringify(res.data.data));
							this.sverList = JSON.parse(sessionStorage.getItem("fenlei4"));
						}
					}).catch((err) => {
						console.log(err);
					});
			} else {
				this.sverList = JSON.parse(sessionStorage.getItem("fenlei4"));
			}

		},
		methods: {
			rent(id, index) {
				this.category_id = id;
				localStorage.setItem("activeKeys", index);
				localStorage.setItem("category_ids", id);
				this.activeKey = localStorage.getItem("activeKeys");
			},
			home() {
				this.$router.push({
					path: '/Home'
				})
			},
			//租购淘详情页面
			goPage(id) {
				this.$router.push({
					path: '/pages',
					query: {
						category_id: this.category_id,
						cat_id: id
					}
				})
			},
			//样板间内容切换
			getData(id, index) {
				this.flag = index;
				this.$axios.post(baseUrl + '/mobile/Category/exhibition', {
					id: id
				}).then((res) => {
					if (res.data.code == 2) {
						this.design = res.data.data.exhibition
					}
				}).catch((err) => {
					console.log(err);
				});
			},
			//第三方详情
			goDetail(id) {
				this.$router.push({
					path: '/ser_detail',
					query: {
						id: id
					}
				})
			}
		},
	}
</script>

<style scoped>
	@import "class.css";
</style>



// WEBPACK FOOTER //
// src/components/class/class.vue